import { render, staticRenderFns } from "./FormAggregateFaixaContribuicao.vue?vue&type=template&id=92e29b2a"
import script from "./FormAggregateFaixaContribuicao.vue?vue&type=script&lang=js"
export * from "./FormAggregateFaixaContribuicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports